import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal, EmailModal, CommonServices } from 'src/modules/shared';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  take,
  map,
  mergeMap,
  switchMap,
  catchError,
  tap,
  takeUntil,
} from 'rxjs/operators';
// import {} from '../models/register';
import { Subject, Subscription } from 'rxjs';
// import { OptionxService } from "../services/options"
// import { RegisterProvider } from "../providers/register"
// import { Optionx ,Register} from "src/modules/shared/models"
import { UserService } from '../../../services';
import {
  AwardLotModal,
  // AppropriationModal,
  // ProcurementTypeModal,
  SelectionMethodModal,
} from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-account-details',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.scss'],
})
export class Step2Component implements OnInit {
  success: any;
  error: any;
  pending: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();
  //   @Input() formValues: any;
  public detailForm: FormGroup;
  public foreignForm: FormGroup;
  public businessForm: FormGroup;
  public valuesProvided: any = {};
  public formSubmitAttempt: boolean = false;
  public collapseForeign: boolean = true;
  public collapse: boolean = true;
  public isCountryName: boolean;
  bizProvider: Array<any> = [];
  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  optionError: boolean;
  optionLoading: boolean;

  cType = [
    {
      optionId: '',
      optionName: '',
      optionDescription: '',
    },
  ];
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
    ],
  };

  userObject = {
    securityQuestion: '',
    answerSecurityQuestion: '',
    appUserEmail: '',
    mobileNumber: '',
    officePhone: '',
    phoneNumber: '',
    fax: '',
    website: '',
    headOfficeAddressCity: '',
    headOfficeAddressZip: '',
    headOfficeAddressPobox: '',
    headOfficeAddressPmb: '',
    companyContactPhone1: '',
    companyContactPhone2: '',
    companyContactAlternativeEmail: '',
    companyContactEmail: '',
    contractorId: '',
    tradeName: '',
    tinNumber: '',
    rcNumber: '',
    bppId: '',
    dateOfRegistration: Object,
    headOfficeAddressStreet: '',
    headOfficeAddressState: '',
    firstName: '',
    lastName: '',
    middleName: '',
  };

  tinValidation: boolean;
  companyValidation: boolean;
  mpending: boolean;
  registrationSidebar;
  source;
  token: string | null = null;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private userSvc: UserService,
    private router: Router,
    private commonSvc: CommonServices
  ) {
    this.mpending = true;
    this.commonSvc
      .getTemplate({ messageTemplateId: 'CONTACT_SIDE_BAR' })
      .subscribe((res: any) => {
        this.registrationSidebar = res.mailTemplate;
        this.mpending = false;
      });
    this.getOptionTypes();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.source = params['source'];
      this.token = params['token'];
    });
    let userObject = JSON.parse(window.localStorage.getItem('userObject'));
    if (userObject) {
      if (userObject.dateOfRegistration) {
        userObject.dateOfRegistration = new Date(userObject.dateOfRegistration);
      } else {
        userObject.dateOfRegistration = new Date();
      }

      if (userObject.headOfficeAddressState) {
        userObject.headOfficeAddressState =
          userObject.headOfficeAddressState.stateId;
      } else {
        userObject.headOfficeAddressState = '321';
      }

      this.userObject = userObject;
      // console.log(this.userObject)
    }

    this.detailForm = this.fb.group({
      rc_number: ['', Validators.required],
      company_type: ['', Validators.required],
      tin_number: [''],
      ownership_type: ['', Validators.required],
      registrationNumber: [''],
      thirdPartyBusinessName: [''],
      companyName: [''],
      thirdPartyBusinessNumber: [''],
      nccId: [''],
    });

    this.foreignForm = this.fb.group({
      companyName: ['', Validators.required],
      registrationNumber: ['', Validators.required],
      thirdPartyBusinessName: ['', Validators.required],
      thirdPartyBusinessNumber: ['', Validators.required],
    });

    this.businessForm = this.fb.group({
      bnNumber: [''],
      tin_number: ['', Validators.required],
      company_type: ['', Validators.required],
      ownership_type: ['', Validators.required],
    });

    this.detailForm.valueChanges.subscribe((res) => {
      // if (res["company_type"] === "business_name_actual") {
      //   console.log("clear validations")
      //   this.isCountryName = true;
      //   this.companyValidation = true;
      //   this.tinValidation = false;
      //   this.detailForm.controls["tin_number"].clearValidators()
      //   this.detailForm.controls["companyName"].setValidators([Validators.required])
      //   this.detailForm.updateValueAndValidity();
      // } else {
      //   console.log("set validations")
      //   this.isCountryName = false;
      //   // this.detailForm.get('tin_number').validator = <any>Validators.compose([Validators.required]);
      //   this.detailForm.controls["companyName"].clearValidators()
      //   this.detailForm.controls["tin_number"].setValidators([Validators.required])
      //   this.detailForm.updateValueAndValidity();
      // }
    });
  }
  toggleCollapse(val) {
    if (
      val.optionId === 'niegria_owned' ||
      val.optionId === 'niegria_company_owned_by_foreign_company'
    ) {
      this.collapse = false;
      this.collapseForeign = true;
    } else {
      this.collapse = true;
      this.collapseForeign = false;
    }
  }
  toggleCollapsex(val) {
    if (val.optionId === 'business_name_actual') {
      console.log('clear validations');
      this.isCountryName = false;
      // this.companyValidation = true;
      // this.tinValidation = false;
      this.detailForm.controls['companyName'].clearValidators();
      this.detailForm.controls['tin_number'].setValidators([
        Validators.required,
      ]);
      this.detailForm.updateValueAndValidity();
    } else {
      console.log('set validations');
      this.isCountryName = false;
      // this.detailForm.get('tin_number').validator = <any>Validators.compose([Validators.required]);
      this.detailForm.controls['companyName'].clearValidators();
      this.detailForm.controls['tin_number'].setValidators([
        Validators.required,
      ]);
      this.detailForm.updateValueAndValidity();
    }
  }
  isFieldValid(field: string) {
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  isForeignFieldValid(field: string) {
    return (
      (!this.foreignForm.get(field).valid &&
        this.foreignForm.get(field).touched) ||
      (this.foreignForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayForeignFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  nextDynamic() {
    console.log(this.detailForm.value);
    this.formSubmitAttempt = false;
    if (
      this.detailForm.valid &&
      this.detailForm.value.company_type !== 'business_name_actual' &&
      this.detailForm.value.company_type !== '' &&
      this.detailForm.value.ownership_type !== 'foreign_owned'
    ) {
      console.log('private');
      const values = this.valuesProvided;

      values.rc_number = this.detailForm.value.rc_number;
      values.company_type = this.detailForm.value.company_type;
      values.tin_number = this.detailForm.value.tin_number;
      values.ownership_type = this.detailForm.value.ownership_type;
      window.localStorage.setItem(
        'userObject',
        JSON.stringify(this.detailForm.value)
      );
      // this.registerService.next(values);
      this.source === 'procurement'
        ? this.router.navigate(['/home-page/sign-up/step3'], {
            queryParams: { source: 'procurement', token: this.token },
          })
        : this.router.navigate(['/home-page/sign-up/step3']);
    } else if (
      this.foreignForm.valid &&
      this.detailForm.value.ownership_type === 'foreign_owned' &&
      this.foreignForm.value.companyName !== ''
    ) {
      const values = this.foreignForm.value;
      console.log('foriegn', values);
      this.detailForm.value.companyName = values.companyName;
      this.detailForm.value.registrationNumber = values.registrationNumber;
      this.detailForm.value.thirdPartyBusinessName =
        values.thirdPartyBusinessName.optionId;
      this.detailForm.value.thirdPartyBusinessNumber =
        values.thirdPartyBusinessNumber;

      values.ownershipType = this.ownershipType.filter(
        (res) => res.optionId === this.detailForm.value.ownership_type
      )[0];
      window.localStorage.setItem(
        'userObject',
        JSON.stringify(this.detailForm.value)
      );
      window.localStorage.setItem('foreignObject', JSON.stringify(values));
      this.router.navigate(['/home-page/sign-up/step4']);
      // this.registerService.static('foreign');
    } else if (
      this.detailForm.valid &&
      this.detailForm.value.company_type === 'business_name_actual'
    ) {
      console.log('business');
      const values = this.valuesProvided;
      values.company_name = this.detailForm.value.companyName;
      values.rc_number = this.detailForm.value.rc_number;
      values.company_type = this.detailForm.value.company_type;
      values.tin_number = this.detailForm.value.tin_number;
      values.ownership_type = this.detailForm.value.ownership_type;
      window.localStorage.setItem(
        'userObject',
        JSON.stringify(this.detailForm.value)
      );
      this.source === 'procurement'
        ? this.router.navigate(['/home-page/sign-up/step3'], {
            queryParams: { source: 'procurement', token: this.token },
          })
        : this.router.navigate(['/home-page/sign-up/step3']);
      // this.registerService.next(values);
    } else {
      this.formSubmitAttempt = true;
    }
  }

  //   dbService() {
  //       mock.mockCompany.data.forEach(company=>{
  //           if(company.rc)
  //       })
  //   }
  cancel() {
    window.localStorage.clear();
    // this.registerService.static('welcome');
  }

  reset() {
    this.detailForm.reset();
    this.formSubmitAttempt = false;
  }

  next(value: string) {
    // this.registerService.static(value);
  }

  goBack() {
    this.location.back();
  }

  getOptionTypes() {
    this.optionError = false;
    this.optionLoading = true;
    this.userSvc
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((res: any) => res.rows),
        map((res) => {
          let options = {
            ownershipType: [],
            companyType: [],
            errorOption: [],
            providerType: [],
          };
          res.forEach((option) => {
            // console.log(option)
            switch (option.optionType.optionTypeId) {
              case 'ownership_type':
                options.ownershipType.push(option);
                break;
              case 'actual_company_type':
                options.companyType.push(option);
                break;
              case 'foreign_company_providers':
                options.providerType.push(option);
                break;
              default:
                options.errorOption.push(option);
            }
          });
          return options;
        })
      )
      .subscribe(
        (res) => {
          // console.log(res);
          this.optionLoading = false;
          this.companyType = res.companyType;
          this.ownershipType = res.ownershipType;
          this.bizProvider = res.providerType;
          window.localStorage.setItem('options', JSON.stringify(res));
        },
        (error) => {
          // console.log(error)
          this.optionError = true;
          this.optionLoading = false;
        }
      );
  }
  ngOnInit(): void {}
}
